import Vue from 'vue';

import BootstrapVue from 'bootstrap-vue';
import Icon from 'vue-awesome/components/Icon.vue';

import App from './App.vue';
import router from './router';
import store from './vuex/store';

import './styles/main.scss';

Vue.use(BootstrapVue);
Vue.component('icon', Icon);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
